import React, { useState } from "react";
import { Input } from "@/components/ui/input";
import { Eye, EyeSlash } from "@phosphor-icons/react";
import { cn } from "@/lib/utils";

export const PasswordInput = React.forwardRef(({ className, ...props }, ref) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className="relative">
      <Input
        type={showPassword ? "text" : "password"}
        className={cn("pr-12", className)}
        ref={ref}
        {...props}
      />
      <button
        type="button"
        onClick={() => setShowPassword(!showPassword)}
        className="absolute right-0 top-0 h-full px-3 flex items-center justify-center min-w-[44px] min-h-[44px]"
        aria-label={showPassword ? "Hide password" : "Show password"}
        tabIndex={-1}
        data-testid="password-toggle"
      >
        {showPassword ? (
          <EyeSlash size={20} weight="regular" className="text-foreground opacity-50" />
        ) : (
          <Eye size={20} weight="regular" className="text-foreground opacity-50" />
        )}
      </button>
    </div>
  );
});

PasswordInput.displayName = "PasswordInput";

export default PasswordInput;
